<h1 mat-dialog-title>
    Sei sicuro di voler eliminare questo Locker?
</h1>
<div mat-dialog-content>
    <p>
        L'eliminazione è definitiva
    </p>
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="warn" (click)="onNoClick()">
        ANNULLA
    </button>
    <button mat-flat-button class="daxa" [mat-dialog-close]="true" cdkFocusInitial>
        CONFERMA
    </button>
</div>